import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "@/App.css";
import { Cursor } from "@/components/Cursor";
import { Nav } from "@/components/Nav";
import { MobileCta } from "@/components/MobileCta";
import Hero from "@/sections/Hero";
import Ticker from "@/sections/Ticker";
import Manifesto from "@/sections/Manifesto";
import Letter from "@/sections/Letter";
import Audience from "@/sections/Audience";
import Roadmap from "@/sections/Roadmap";
import Curriculum from "@/sections/Curriculum";
import Host from "@/sections/Host";
import Transformation from "@/sections/Transformation";
import Takeaways from "@/sections/Takeaways";
import Faq from "@/sections/Faq";
import FinalRegister from "@/sections/FinalRegister";
import Footer from "@/sections/Footer";
import ThankYou from "@/pages/ThankYou";
import Replay from "@/pages/Replay";
import { Privacy, Terms } from "@/pages/LegalPages";

gsap.registerPlugin(ScrollTrigger);

function Landing() {
  useEffect(() => {
    document.title = "Matthew Lake-Nestor | The VA Home-Ready Blueprint";
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.__lenis = lenis;
    lenis.on("scroll", ScrollTrigger.update);
    const raf = (time) => lenis.raf(time * 1000);
    gsap.ticker.add(raf);
    gsap.ticker.lagSmoothing(0);
    return () => {
      gsap.ticker.remove(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="wam-page" data-testid="wam-page">
      <div className="grain-overlay" />
      <Nav />
      <main>
        <Hero />
        <Ticker />
        <Manifesto />
        <Host />
        <Letter />
        <Audience />
        <Roadmap />
        <Curriculum />
        <Transformation />
        <Takeaways />
        <Faq />
        <FinalRegister />
        <Footer />
      </main>
      <MobileCta />
    </div>
  );
}

function App() {
  useEffect(() => {
    const fa = document.createElement("link");
    fa.rel = "stylesheet";
    fa.href = "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css";
    document.head.appendChild(fa);
  }, []);

  return (
    <BrowserRouter>
      <Cursor />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/replay" element={<Replay />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
